var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_2990003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9551",
    d: "M6.60527 7.68308L6.34622 6.59776C6.27469 6.2739 5.98003 6.0488 5.64877 6.06499C5.21789 6.08556 4.91432 6.49616 5.02174 6.91393L5.69926 9.71964C5.78721 10.0838 6.15307 10.3083 6.51759 10.2218L9.32464 9.54955C10.2085 9.33515 9.88703 8.00946 9.00316 8.22378L7.65343 8.5492C8.58785 7.3692 9.96484 6.54468 11.583 6.3719C14.783 6.0302 17.6392 8.3383 17.9809 11.5383C18.0544 12.4709 19.463 12.319 19.336 11.3923C18.9425 7.70694 15.8053 4.96257 11.8095 5.00039C9.4638 5.23227 7.75862 6.23863 6.60527 7.68308ZM15.0676 14.4303C14.1474 14.6188 14.4795 16.0042 15.3851 15.7549L16.7335 15.4294C15.7991 16.609 14.4223 17.4299 12.8039 17.6027C9.60393 17.9444 6.74903 15.6416 6.40733 12.4416C6.37456 12.0854 6.07149 11.8154 5.71387 11.8239C5.31204 11.8342 5.00673 12.1889 5.05628 12.5878C5.47605 16.5188 9.01771 19.3789 12.9487 18.9591C14.9265 18.748 16.6297 17.7383 17.783 16.2956L18.046 17.3822C18.2117 18.3335 19.6497 17.9892 19.3665 17.066L18.693 14.259C18.6164 13.9352 18.3169 13.7143 17.9271 13.7469L15.0676 14.4303Z",
    fill: "#A1A1A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.335da9413061a619d3b6bbd8121333f3.svg";
export { ForwardRef as ReactComponent };